<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3335 0V16H18.3335V18H0.333496V0H2.3335ZM17.6265 3.293L19.0405 4.707L13.3335 10.414L10.3335 7.415L6.0405 11.707L4.6265 10.293L10.3335 4.586L13.3335 7.585L17.6265 3.293Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "ChartsIcon",
};
</script>
